import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import apiStore from './store/apiStore';
import { Provider } from 'react-redux';
import App from './App';
import './main.css';
import { RootErrorBoundary } from './components/errorBoundary';
import apm from './apm/agent';

apm.init();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <RootErrorBoundary>
      <BrowserRouter>
        <Provider store={apiStore}>
          <App />
        </Provider>
      </BrowserRouter>
    </RootErrorBoundary>
  </React.StrictMode>,
);
